import {call, put, take, takeEvery} from 'redux-saga/effects';
import {USER_FETCH_MODEL, USER_SET_ACCESS_TOKEN} from './constants';
import app from '../../helpers/app';
import {IUser} from '../../@interfaces/services/Auth/IUser';
import {fetchUserModel, setUserModel} from './actions';
import {APP_LOADED} from '../app/constants';
import {setUnreadNotificationsNumber} from '../notifications/actions';

export function* watchUserAccessTokenSetting() {
    yield takeEvery(USER_SET_ACCESS_TOKEN, function* () {
        yield put(fetchUserModel());
    });
}

export function* fetchUserModelSaga() {
    yield takeEvery(USER_FETCH_MODEL, function* () {
        if (!app().isLoaded()) {
            yield take(APP_LOADED);
        }

        const model: IUser | null = yield call(() => app('auth').fetchUser());
        if (!model) {
            return;
        }

        yield put(setUserModel(model.toArray()));
        if ('unread_notifications_count' in model) {
            yield put(setUnreadNotificationsNumber(model.unread_notifications_count));
        }
    });
}
